module.exports = __webpack_public_path__ + "static/media/car11.2cbf24a3.JPG";